'use strict';

require('bootstrap/js/src/tooltip.js');

const SELECTORS = {
    body: 'body',
    tooltip: '[data-toggle="tooltip"]'
};

module.exports = {
    init: function() {
        $(SELECTORS.body).tooltip({
            selector: SELECTORS.tooltip
        });

        $(SELECTORS.body).on('click', SELECTORS.tooltip, function() {
            $(this).tooltip('show');
        })
    }
};
